import React from 'react';
import { MyModal } from '../my-modal';
import { Button } from '../button';
import { LegalDocumentContent } from './LegalDocumentContent';
import { LEGAL_DOCUMENTS, LegalDocKind } from './legalDocuments';

interface Props {
  kind: LegalDocKind | null;
  onClose: () => void;
  /** Если передан — внизу кнопка «Принимаю», отмечающая соответствующий чекбокс. */
  onAccept?: () => void;
}

/** Модалка с текстом согласия. Обычная MyModal (шапка, крестик, Esc, скролл). */
export const LegalDocumentModal: React.FC<Props> = ({ kind, onClose, onAccept }) => (
  <MyModal
    isOpen={kind !== null}
    onClose={onClose}
    size="lg"
    title={kind ? LEGAL_DOCUMENTS[kind].title : ''}
  >
    {kind && (
      <>
        <LegalDocumentContent kind={kind} />
        <div className="flex justify-end gap-2 mt-6">
          <div className="w-[160px]">
            <Button isWhite onClick={onClose}>
              Закрыть
            </Button>
          </div>
          {onAccept && (
            <div className="w-[160px]">
              <Button
                onClick={() => {
                  onAccept();
                  onClose();
                }}
              >
                Принимаю
              </Button>
            </div>
          )}
        </div>
      </>
    )}
  </MyModal>
);
